import { Permission } from '@cims-online/shared'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { simpleRestoreNotification } from 'hooks/notificationHandler'
import { useRestoreDsDisciplineMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import {
  Discipline,
  useDisciplinesTableContext,
} from '../../../../DisciplinesTableContext'

export function useRestore(): RestoreRowActionOptions<Discipline> {
  const { refetch } = useDisciplinesTableContext()
  const [restore] = useRestoreDsDisciplineMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreDSDiscipline: {
        discipline: { name },
      },
    }) => simpleRestoreNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreDesignSubmittalDiscipline,
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      refetch()
    },
    metadata: ({ deleted, deletedUser, deletedDate }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    default: 'active',
  }
}
